import React, { Component } from "react";
import { Col, Row } from "reactstrap";

import DashboardCard from "./DashboardCard";
import OrderPieChart from "./OrderPieChart";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import dashboardReducer from "store/Dashboard/reducer";
import dashboardSaga from "store/Dashboard/saga";
import { makeDashboardSelectField } from "store/Dashboard/selector";
import { createStructuredSelector } from "reselect";
import { getAdminDashboardDataRequest } from "store/actions";

const dashboardKey = "Dashboard";

const withDashboardReducer = injectReducer({
  key: dashboardKey,
  reducer: dashboardReducer,
});
const withDashboardSaga = injectSaga({
  key: dashboardKey,
  saga: dashboardSaga,
});

class Index extends Component {
  componentDidMount() {
    this.props.getAdminDashboardDataRequest();
  }

  render() {
    const { totalProductsCount, ordersData } = this.props.dashboardApiResponse
      ? this.props.dashboardApiResponse.responseData
      : {};
    return (
      <React.Fragment>
        <div className="content">
          {this.props.dashboardApiResponse && (
            <div className="container-fluid pt-4">
              <Row>
                <Col sm="6" md="6" lg="3">
                  <DashboardCard
                    icon="dripicons-broadcast"
                    title="Total Products"
                    count={totalProductsCount}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md="6">
                  <OrderPieChart ordersData={ordersData} />
                </Col>
              </Row>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  dashboardApiResponse: makeDashboardSelectField("dashboardApiResponse"),
});

const withConnect = connect(mapStatetoProps, {
  getAdminDashboardDataRequest,
});

export default compose(
  withConnect,
  withDashboardReducer,
  withDashboardSaga,
  withRouter
)(Index);
